import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const StyledGlassPanel = styled.div`
  display: flex;
  align-items: center;
  gap: ${tokens.space.sm};
  height: 2.5rem;
  padding: 0 ${tokens.space.sm};
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.control};
  color: ${tokens.text.secondary};
  font-size: ${tokens.font.body};
`
